import isPresent from './isPresent';

export default error => isPresent(error?.message) && error.message === 'canceled';
